import { render, staticRenderFns } from "./MultiselectDropdownItems.vue?vue&type=template&id=64486a00&scoped=true&"
import script from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdownItems.vue?vue&type=style&index=0&id=64486a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64486a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64486a00')) {
      api.createRecord('64486a00', component.options)
    } else {
      api.reload('64486a00', component.options)
    }
    module.hot.accept("./MultiselectDropdownItems.vue?vue&type=template&id=64486a00&scoped=true&", function () {
      api.rerender('64486a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/MultiselectDropdownItems.vue"
export default component.exports